export enum PetTypeEnum {
  Cat = 'Cat',
  Dog = 'Dog',
  Custom = 'Custom',
}
